var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.06,
    viewBox: "0 0 12 12.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727275",
    d: "M1.8 1.8A5.759 5.759 0 0 1 6.06 0a5.537 5.537 0 0 1 4.2 1.8A5.7 5.7 0 0 1 12 6.06a5.939 5.939 0 0 1-1.74 4.26A5.7 5.7 0 0 1 6 12.06a5.939 5.939 0 0 1-4.26-1.74A5.7 5.7 0 0 1 0 6.06 6.141 6.141 0 0 1 1.8 1.8zm.84 7.62A4.638 4.638 0 0 0 6 10.86a4.541 4.541 0 0 0 3.36-1.44 4.638 4.638 0 0 0 1.44-3.36A4.448 4.448 0 0 0 9.36 2.7a4.265 4.265 0 0 0-3.3-1.5A4.541 4.541 0 0 0 2.7 2.64 4.638 4.638 0 0 0 1.26 6a4.4 4.4 0 0 0 1.38 3.42zM5.46 3h1.2v3.6h-1.2zm0 4.8h1.2V9h-1.2z",
    transform: "translate(12 12.06) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinfo);
export default __webpack_public_path__ + "static/media/iconinfo.6cf89ba1f2067b5705961073c616f18c.svg";
export { ForwardRef as ReactComponent };